module.exports = __webpack_public_path__ + "img/chuangyi.d3180da2.png";